import * as React from 'react';
import { ToastProvider, TooltipProvider } from '@/components/ui';

const UiPortalContainerContext = React.createContext(null);

const ScopedUiRoot = ({ children }) => {
    const [portalContainer, setPortalContainer] = React.useState(null);

    return (
        <UiPortalContainerContext.Provider value={portalContainer}>
            <TooltipProvider>
                {children}
                <ToastProvider />
                <div data-ui-portal-root="" ref={setPortalContainer} />
            </TooltipProvider>
        </UiPortalContainerContext.Provider>
    );
};

const renderWithUiRoot = (reactRoot, container, node) => {
    if (container) {
        // Single isolation container after the Sprint 0 ui_root -> ui_reset
        // collapse. The `ui-root` class is no longer styled.
        container.classList.add('ui-reset');
    }

    reactRoot.render(<ScopedUiRoot>{node}</ScopedUiRoot>);
};

const resolveReactMountContainer = (viewOrElement) => {
    if (viewOrElement instanceof HTMLElement) {
        return viewOrElement;
    }

    const element = viewOrElement?.el;

    if (element instanceof HTMLElement) {
        return element;
    }

    const id = typeof viewOrElement === 'string' ? viewOrElement : viewOrElement?.id;

    if (typeof id === 'string' && id.length > 0) {
        return document.getElementById(id);
    }

    return null;
};

const useUiPortalContainer = () => React.useContext(UiPortalContainerContext);

export { renderWithUiRoot, resolveReactMountContainer, useUiPortalContainer };
